// extracted by mini-css-extract-plugin
export default {"PaymentControl":"PaymentModal_PaymentControl__eIg8h","ButtonIcon":"PaymentModal_ButtonIcon__m9-DZ"};